export const dateToComponents = (date: string): string[] => {
  if (date === "1980-01-01 00:00:00") return ["Нет", "данных"];
  return date.split(" ");
};
